import PropTypes from 'prop-types';
import signInImg from '../../sign-in-with-microsoft-light.png';

function MicrosoftLogin({ url }) {
  return (
    <a id="authzEndpoint" href={url}>
      <img src={signInImg} alt="Sign in with Microsoft" />
    </a>
  );
}

MicrosoftLogin.propTypes = {
  url: PropTypes.string,
};

export default MicrosoftLogin;
